import * as React from "react";
import Slider from "@mui/material/Slider";

import styles from "../functional.module.scss";

export default function Modal({
  open,
  setOpen,
  amount,
  setAmount,
  handleWithdraw,
  handleDepositAmount,
}) {
  const handleChangeAmount = (e) => {
    setAmount(e.target.value.replace(/\D/g, ""));
  };

  return (
    <div className={styles.alertWith}>
      <span>Amount</span>
      <input
        className={styles.alertInput}
        value={amount}
        onChange={handleChangeAmount}
      />
      <Slider
        aria-label="Temperature"
        sx={{
          width: "100%",
          cursor: "pointer",
          color: "#29f917",
          marginTop: "0.5rem",
        }}
        value={amount}
        min={0}
        background="#24D5A9"
        onChange={handleDepositAmount}
      />
      <div className={styles.buttonWrapper}>
        <button onClick={handleWithdraw}>Withdraw</button>
      </div>
    </div>
  );
}
